import React, { Component } from 'react';
import IFlightDetails from 'src/models/flight-details.interface';
// images
const BA = require('../../images/min/ba-min.svg');
const AA = require('../../images/min/aa-min.svg');
const VS = require('../../images/min/vs-min.svg');
const LX = require('../../images/min/lx-min.svg');
const EDW = require('../../images/min/edw-min.svg');
const OS = require('../../images/min/os-min.svg');
const LH = require('../../images/min/lh-min.svg');
const AF = require('../../images/min/af-min.svg');
const KL = require('../../images/min/kl-min.svg');
const SQ = require('../../images/min/sq-min.svg');
const EK = require('../../images/min/ek-min.svg');
const U2 = require('../../images/min/u2-min.svg');
const EZY = require('../../images/min/u2-min.svg');
// NEW AIRLINE
const A3 = require('../../images/min/a3-min.svg');
const AC = require('../../images/min/ac-min.svg');
const AZ = require('../../images/min/az-min.svg');
const DL = require('../../images/min/dl-min.svg');
const SN = require('../../images/min/sn-min.svg');
const TG = require('../../images/min/tg-min.svg');
const TK = require('../../images/min/tk-min.svg');
const TP = require('../../images/min/tp-min.svg');
const UA = require('../../images/min/ua-min.svg');
const UX = require('../../images/min/ux-min.svg');
const DE = require('../../images/min/de-min.svg');

const departure = require('../../images/flight-departure.svg');
const arrival = require('../../images/flight-arrival.svg');

const LOGOS = {
  BA: BA,
  AA: AA,
  VS: VS,
  LX: LX,
  EDW: EDW,
  OS: OS,
  LH: LH,
  AF: AF,
  KL: KL,
  SQ: SQ,
  EK: EK,
  U2: U2,
  EZY: EZY,
  // NEW AIRLINE
  A3: A3,
  AC: AC,
  AZ: AZ,
  DL: DL,
  SN: SN,
  TG: TG,
  TK: TK,
  TP: TP,
  UA: UA,
  UX: UX,
  DE: DE,
};

interface IProps {
  statusHandler: any;
  flightDetails: IFlightDetails;
  language: string;
  multiLang: any;
  languageCode: string;
  handleLanguageChange: any;
  step: number;
}

export class FlightDetailsComponent extends Component<IProps> {
  render() {
    const { language, multiLang, step } = this.props;
    const flightDetails = this.props.flightDetails;
    return (
      <>
        <div className='preStep'>
          {/* <div className='preStep__title'>
            <h2>{multiLang[`yourFlightTitle${language}`]}</h2>
          </div> */}
          <div className='preStep__panel'>
            <div className='preStep__header'>
              <h2>{multiLang[`yourFlightPanelTitle${language}`]}</h2>
            </div>
            <div className='preStep__body preStep__body__flight-detail'>
              <div className='contentBox'>
                <div className='section-flight-number'>
                  <img
                    src={
                      LOGOS[
                      flightDetails
                        .marketingAirlineCode
                      ]
                    }
                    alt={LOGOS[flightDetails.marketingAirlineCode] + '-airline'}
                  />
                  {flightDetails.marketingAirlineCode}
                  {flightDetails.flightNumber}
                </div>
                <div className='section-flight-info'>
                  <div className='section-flight-details'>
                    <div>
                      <p className='flight-time'>
                        {flightDetails.departureTimeText ??
                          '-'}
                      </p>
                      <p className='flight-location'>
                        {flightDetails.departureAirportCityName ??
                          '-'}
                      </p>
                      <p className='flight-date'>
                        {flightDetails.departureDateText ??
                          '-'}
                      </p>
                    </div>
                    <div>
                      <p className='flight-time'>
                        {flightDetails.arrivalTimeText ??
                          '-'}
                      </p>
                      <p className='flight-location'>
                        {flightDetails.arrivalAirportCityName ??
                          '-'}
                      </p>
                      <p className='flight-date'>
                        {flightDetails.arrivalDateText ??
                          '-'}
                      </p>
                    </div>
                  </div>
                  <div className='section-airport-details'>
                    <div className='section-flight-directions'>
                      <img
                        src={departure}
                        height={'20'}
                        width='20'
                        alt='flight departure'
                      />
                      <img
                        src={arrival}
                        height={'20'}
                        width='20'
                        alt='flight arrival'
                      />
                    </div>

                    <hr />

                    <div className='section-airport-name'>
                      <div className='section-airport-name__badge'>
                        {
                          flightDetails.depatureAirportName
                        }
                      </div>
                      <div className='section-airport-name__badge'>
                        {
                          flightDetails.arrivalAirportName
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='grayBox'>
                <p>
                  {multiLang[`yourFlightPanelMessage${language}`]}
                </p>
              </div>
              <div className='preStep__footer'>
                <button
                  className='btn btn__purple'
                  onClick={() => this.props.statusHandler(step + 1)}
                >
                  {multiLang[`yourFlightPanelButton${language}`]}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default FlightDetailsComponent;



// WEBPACK FOOTER //
// ./src/components/flight-details/flight-details.component.tsx